import { render } from "./AdminInicioComponent.vue?vue&type=template&id=6ae3116a&scoped=true"
import script from "./AdminInicioComponent.vue?vue&type=script&lang=js"
export * from "./AdminInicioComponent.vue?vue&type=script&lang=js"

import "./AdminInicioComponent.vue?vue&type=style&index=0&id=6ae3116a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae3116a"]])

export default __exports__